import axios, { AxiosResponse } from 'axios';
import { authFetch } from '.';
import { IListingInteractionType } from '../models';

const baseUrl = '/api/Admin/ListingInteraction';

export const IListingInteractionTypesAPI = {
  async getAll(): Promise<IListingInteractionType[]> {
    try {
      const response: AxiosResponse<IListingInteractionType[]> = await authFetch.get(baseUrl);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const error = new Error('Request failed with status: ' + err.response?.status);

        error.name = 'AxiosError';
        (error as any).responseData = err.response?.data;
        return Promise.reject(error);
      }

      return Promise.reject(new Error('An unexpected error occurred'));
    }
  },

  async upsert(upsertData: IListingInteractionType[]): Promise<IListingInteractionType[]> {
    try {
      const response: AxiosResponse<IListingInteractionType[]> = await authFetch.post(baseUrl, upsertData);

      return response.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        const error = new Error('Request failed with status: ' + err.response?.status);

        error.name = 'AxiosError';
        (error as any).responseData = err.response?.data;
        return Promise.reject(error);
      }

      return Promise.reject(new Error('An unexpected error occurred'));
    }
  },

  async delete(listingInteractionTypeId: number): Promise<void> {
    try {
      const response = await authFetch.delete(`${baseUrl}/${listingInteractionTypeId}`);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
    }
  },
};
